import {all} from 'redux-saga/effects'

import modals from './modals/index.js'
import returnOrderList from '../../../ordoro/ReturnOrderListPage/returnOrderListSagas.js'
import {purchaseOrderListModalSagas} from '../../../ordoro/PurchaseOrderListPage/Modals/index.js'
import productListModals from '../../../ordoro/ProductListPage/Modals/modalsSagas.js'

export default function* uiSaga() {
  yield all([
    modals(),
    productListModals(),
    returnOrderList(),
    purchaseOrderListModalSagas(),
  ])
}
